export const DELIVERY_LABEL = { ambil: "Ambil sendiri", antar: "Diantar" };

export const MODE_LABEL = {
  menyusul: "Ongkir menyusul (dikonfirmasi lewat WA)",
  per_km: "Tarif per km",
  zona: "Zona dengan tarif tetap",
};

export const EMPTY_DELIVERY = { method: "ambil", address: "", km: "", zone: "" };

// Returns null when the fee is unknown (mode "menyusul")
export const calcShipping = (store, d) => {
  if (d.method !== "antar") return 0;
  if (store.delivery_mode === "per_km") return Math.ceil((Number(d.km) || 0) * (store.rate_per_km || 0));
  if (store.delivery_mode === "zona") return store.zones?.[Number(d.zone)]?.fee ?? 0;
  return null;
};

export const deliveryError = (store, d) => {
  if (d.method !== "antar") return "";
  if (!d.address.trim()) return "Alamat pengiriman wajib diisi";
  if (store.delivery_mode === "per_km" && !(Number(d.km) > 0 && Number(d.km) <= 100)) return "Isi jarak antara 0,1 - 100 km";
  if (store.delivery_mode === "zona" && d.zone === "") return "Pilih zona pengiriman";
  return "";
};

export const deliveryDetail = (store, d) => {
  if (store.delivery_mode === "per_km") return `Jarak: ${d.km} km`;
  if (store.delivery_mode === "zona") return `Zona: ${store.zones?.[Number(d.zone)]?.name || "-"}`;
  return "";
};
